module.exports = __webpack_public_path__ + "img/cobbl6.7cdb7de0.jpeg";